// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.commend-title[data-v-484d88e4] {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  margin: 10px 0px;\n}\n", ""]);
// Exports
module.exports = exports;
